import TimeToGoMeasurement from './TimeToGoMeasurement';

export default TimeToGoMeasurement;
